module.exports = require('./helpers/bundle-url').getBundleURL('dg7cp') + "logo.c51670a8.svg";